import { motion } from "framer-motion";
import { CalendarCheck, MessageCircle } from "lucide-react";
import { WHATSAPP_URL, BOOKING_URL } from "@/data/menu";

export const Navbar = ({ bookingUrl = BOOKING_URL }) => (
  <motion.header
    initial={{ opacity: 0, y: -16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="fixed inset-x-0 top-0 z-50 glass"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between gap-1.5 px-2.5 py-3 sm:gap-2 sm:px-4 sm:py-4 md:px-8">
      <a href="/" data-testid="navbar-logo-link" className="text-center leading-none">
        <span className="font-display text-[11px] tracking-[0.12em] text-[#D4AF37] sm:text-base sm:tracking-[0.3em] md:text-xl md:tracking-[0.35em]">
          BAIANEIRA
        </span>
        <span className="mt-1 hidden text-[9px] tracking-[0.5em] text-[#A3A3A3] sm:block">
          SUSHI FUSION
        </span>
      </a>
      <div className="flex items-center gap-1.5 sm:gap-2">
        <a
          href="/menu/menu-baianeira.pdf"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="navbar-menu-link"
          className="border border-[#D4AF37]/50 px-2.5 py-2.5 text-[10px] font-semibold tracking-[0.05em] text-[#F3E5AB] transition-colors hover:bg-[#D4AF37] hover:text-[#050505] sm:px-3 sm:text-[9px] sm:tracking-[0.2em] md:px-5 md:text-[10px] md:tracking-[0.25em]"
        >
          MENÙ
        </a>
        <a
          data-testid="navbar-prenota-button"
          href={bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 bg-[#25D366] px-3 py-2.5 text-[11px] font-bold tracking-[0.02em] text-[#05220f] transition-transform active:scale-[0.97] sm:gap-2 sm:px-3 sm:text-[9px] sm:tracking-[0.2em] md:px-5 md:text-[10px] md:tracking-[0.25em]"
        >
          <CalendarCheck size={15} /> PRENOTA
        </a>
        <a
          data-testid="navbar-whatsapp-button"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden items-center gap-1.5 border border-[#25D366]/70 px-3 py-2.5 text-[11px] font-bold tracking-[0.02em] text-[#25D366] transition-colors duration-300 hover:bg-[#25D366] hover:text-[#05220f] sm:flex sm:gap-1.5 sm:px-4 sm:text-[10px] sm:tracking-[0.2em] md:text-[10px]"
        >
          <MessageCircle size={15} /> WHATSAPP
        </a>
      </div>
    </div>
  </motion.header>
);

export default Navbar;
